'use strict';
(() => {
  const key='mcc-wishlist-intent', valid=h=>typeof h==='string'&&/^[a-z0-9][a-z0-9-]{0,199}$/.test(h);
  function decode(value){
    const list=value==null?[]:JSON.parse(value);
    if(!Array.isArray(list)||list.length>100||list.some(h=>!valid(h)))throw Error('Your wishlist could not be read. Please contact support.');
    return [...new Set(list)];
  }
  function prepare(){
    const h=new URLSearchParams(location.search).get('wish');
    if(valid(h))try{sessionStorage.setItem(key,JSON.stringify({handle:h,at:Date.now()}));const u=new URL(location.href);u.searchParams.delete('wish');history.replaceState(null,'',u.pathname+u.search+u.hash);}catch{}
  }
  function intent(){try{const p=JSON.parse(sessionStorage.getItem(key));return p&&valid(p.handle)&&Date.now()-p.at<900000?p.handle:null;}catch{return null;}}
  async function mount(query,ownerId){
    const status=document.getElementById('wishlist-status'),list=document.getElementById('wishlist-items'),pending=document.getElementById('wishlist-pending'),refresh=document.getElementById('wishlist-refresh');
    let busy=false;
    const node=(tag,text)=>{const n=document.createElement(tag);if(text!=null)n.textContent=text;return n;};
    const message=t=>{status.textContent=t;};
    async function product(handle){
      const r=await fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin',signal:AbortSignal.timeout(15000)});
      if(r.status===404)return null;
      if(!r.ok)throw Error('Product details are temporarily unavailable. Please refresh.');
      const p=await r.json();if(p.handle!==handle||typeof p.title!=='string')throw Error('Product details could not be verified.');return p;
    }
    async function read(){
      const c=(await query('query MCCWishlist { customer { id metafield(namespace:"custom",key:"mcc_wishlist") { value compareDigest } } }')).customer;
      if(c?.id!==ownerId)throw Error('Please sign in again.');
      return {items:decode(c.metafield?.value),digest:c.metafield?.compareDigest??null};
    }
    async function update(handle,add){
      for(let attempt=0;attempt<3;attempt++){
        const current=await read();
        const items=add?[...new Set([...current.items,handle])]:current.items.filter(h=>h!==handle);
        if(items.length>100)throw Error('Your wishlist holds up to 100 products. Remove one before adding another.');
        if(JSON.stringify(items)===JSON.stringify(current.items))return;
        const result=(await query('mutation MCCWishlistSave($metafields:[MetafieldsSetInput!]!){metafieldsSet(metafields:$metafields){metafields{value} userErrors{code message}}}',{metafields:[{ownerId,namespace:'custom',key:'mcc_wishlist',type:'json',value:JSON.stringify(items),compareDigest:current.digest}]})).metafieldsSet;
        if(!result)throw Error('Your wishlist was not saved. Please try again.');
        if(!result.userErrors?.length)return;
        if(result.userErrors.every(e=>/COMPARE|STALE/i.test(e.code||'')))continue;
        throw Error('Your wishlist was not saved. '+result.userErrors.map(e=>e.message).join(' '));
      }
      throw Error('Your wishlist changed on another device. Please try again.');
    }
    async function action(fn){
      if(busy)return;busy=true;refresh.disabled=true;
      document.querySelectorAll('#wishlist-items button,#wishlist-pending button').forEach(b=>b.disabled=true);
      try{await fn();}catch(e){message(e.message);}finally{busy=false;refresh.disabled=false;document.querySelectorAll('#wishlist-items button,#wishlist-pending button').forEach(b=>b.disabled=false);}
    }
    function button(text,fn){const b=node('button',text);b.type='button';b.onclick=()=>action(fn);return b;}
    async function render(){
      message('Loading your saved products…');
      const {items}=await read();list.replaceChildren();
      // Fetch in small batches to avoid overwhelming the storefront.
      for(let start=0;start<items.length;start+=4){
        const batch=items.slice(start,start+4);
        const results=await Promise.all(batch.map(async h=>{try{return {h,p:await product(h)};}catch{return {h,error:true};}}));
        for(const {h,p,error} of results){
          const card=node('article');card.className='mcc-wishlist-item';
          if(p){
            if(p.featured_image){const u=new URL(p.featured_image,location.origin);if(u.protocol==='https:'&&(u.origin===location.origin||u.hostname==='cdn.shopify.com')){const img=node('img');img.src=u.href;img.alt=p.title;img.loading='lazy';img.width=240;img.height=180;card.append(img);}}
            card.append(node('h3',p.title));
            card.append(node('p',p.available?'Available - choose your size on the product page':'Currently sold out'));
            const a=node('a','View product / choose options →');a.href='/products/'+encodeURIComponent(h);card.append(a);
          }else{card.append(node('h3',h.replaceAll('-',' ')),node('p',error?'Product details could not be loaded. Try Refresh.':'This product is no longer available.'));}
          card.append(button('Remove from wishlist',async()=>{await update(h,false);await render();message('Removed from your wishlist.');}));list.append(card);
        }
      }
      message(items.length?items.length+' saved product'+(items.length===1?'':'s')+'.':'Your wishlist is empty. Tap Wishlist beside a product to save a favourite.');
    }
    refresh.onclick=()=>action(render);
    const h=intent();
    if(h){
      location.hash='wishlist';
      pending.hidden=false;pending.replaceChildren(node('p','Loading selected product…'));
      try{
        const p=await product(h);pending.replaceChildren();
        if(p){
          if(p.featured_image){const u=new URL(p.featured_image,location.origin);if(u.protocol==='https:'&&(u.origin===location.origin||u.hostname==='cdn.shopify.com')){const img=node('img');img.src=u.href;img.alt=p.title;img.width=140;img.height=140;pending.append(img);}}
          pending.append(node('h3',p.title),button('Save to my wishlist',async()=>{await update(h,true);try{sessionStorage.removeItem(key);}catch{}pending.hidden=true;await render();message('Saved to your Shopify account.');}));}
        else pending.append(node('p','The selected product is no longer available.'));
        pending.append(button('Dismiss',async()=>{try{sessionStorage.removeItem(key);}catch{}pending.hidden=true;}));
      }catch(e){pending.replaceChildren(node('p',e.message));}
    }
    await action(render);
  }
  window.MCCWishlist={prepare,mount};
  if(typeof module!=='undefined')module.exports={decode,valid};
})();
